import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/pub/Home'
// import Regulamento from '@/pages/pub/Regulamento'
// import Percurso from '@/pages/pub/Percurso'
// import Inscricao from '@/pages/pub/Inscricao'
import ListaInscritos from '@/pages/pub/ListaInscritos'
import Tempo from '@/pages/pub/Tempo'
import Resultados from '@/pages/pub/Resultados'
import Contacto from '@/pages/pub/Contacto'
import OrgPainel from '@/pages/org/Painel'
import OrgInscricao from '@/pages/org/Inscricao'
import OrgListaInscritos from '@/pages/org/ListaInscritos'
import OrgEstatistica from '@/pages/org/Estatistica'
import OrgControlo1 from '@/pages/org/Controlo1'
import OrgControlo2 from '@/pages/org/Controlo2'
import CpPainel from '@/pages/cp/Painel'
import CpInscricao from '@/pages/cp/Inscricao'
import CpListaInscritos from '@/pages/cp/ListaInscritos'
import CpInicio from '@/pages/cp/Inicio'
import CpChegadas from '@/pages/cp/Chegadas'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    // {
    //   path: '/regulamento',
    //   name: 'Regulamento',
    //   component: Regulamento
    // },
    // {
    //   path: '/percurso',
    //   name: 'Percurso',
    //   component: Percurso
    // },
    // {
    //   path: '/inscricao',
    //   name: 'Inscricao',
    //   component: Inscricao
    // },
    {
      path: '/lista-inscritos',
      name: 'ListaInscritos',
      component: ListaInscritos
    },
    {
      path: '/tempo',
      name: 'Tempo',
      component: Tempo
    },
    {
      path: '/resultados',
      name: 'Resultados',
      component: Resultados
    },
    {
      path: '/contacto',
      name: 'Contacto',
      component: Contacto
    },
    {
      path: '/org',
      name: 'OrgPainel',
      component: OrgPainel
    },
    {
      path: '/org/inscricao',
      name: 'OrgInscricao',
      component: OrgInscricao
    },
    {
      path: '/org/lista-inscritos',
      name: 'OrgListaInscritos',
      component: OrgListaInscritos
    },
    {
      path: '/org/estatistica',
      name: 'OrgEstatistica',
      component: OrgEstatistica
    },
    {
      path: '/org/controlo1',
      name: 'OrgControlo1',
      component: OrgControlo1
    },
    {
      path: '/org/controlo2',
      name: 'OrgControlo2',
      component: OrgControlo2
    },
    {
      path: '/cp',
      name: 'CpPainel',
      component: CpPainel
    },
    {
      path: '/cp/inscricao',
      name: 'CpInscricao',
      component: CpInscricao
    },
    {
      path: '/cp/lista-inscritos',
      name: 'CpListaInscritos',
      component: CpListaInscritos
    },
    {
      path: '/cp/inicio',
      name: 'CpInicio',
      component: CpInicio
    },
    {
      path: '/cp/chegadas',
      name: 'CpChegadas',
      component: CpChegadas
    }
  ],
  mode: 'history',
  linkActiveClass: 'active'
})



// WEBPACK FOOTER //
// ./src/router/index.js